import { NgModule } from "@angular/core";
import { BecentralRecaptchaComponent } from "./recaptcha.component";

@NgModule({
    declarations: [BecentralRecaptchaComponent],
    imports: [],
    exports: [BecentralRecaptchaComponent]
})
export class BecentralRecaptchaModule { }